import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getDisposal45Totals } from "../../../../../apis/Product/DisposalFlow45Api";

// Using a simple SVG icon for disposal
const Disposal45Icon = () => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 25H56V65C56 67.2091 54.2091 69 52 69H24C21.7909 69 20 67.2091 20 65V25Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28 25V19C28 16.7909 29.7909 15 32 15H44C46.2091 15 48 16.7909 48 19V25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32 35V55" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M44 35V55" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Disposal45Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalDisposalItem, setTotalDisposalItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getDisposal45Totals({
        productId,
        setTotals: setTotalDisposalItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-disposal-45-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-disposal-45-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`disposal-45-category ${className || ""}`}
      leftBoxProps={{
        icon: <Disposal45Icon />,
        title: t("DISPOSAL") || "Disposal",
        description:
          t("DISPOSAL_DESC") ||
          "Includes the final treatment of the product fraction that cannot be reused or recycled. Typical processes are landfill and incineration without energy recovery.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_45") || "Total for Flow 45",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalDisposalItem?.impact_totals || null,
        lastUpdated: totalDisposalItem?.updated_at
          ? formatDate(totalDisposalItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Disposal45Header;

